import { h } from 'preact';
export const Target = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "12", cy: "12", r: "10" }),
        h("circle", { cx: "12", cy: "12", r: "6" }),
        h("circle", { cx: "12", cy: "12", r: "2" })));
};
//# sourceMappingURL=target.js.map